import gaParams from '../../utilities/analytics/constants';
import { gaEvent, gaInit, gaPageView, fbqEvent, gaReportFormSuccessAllWebSiteEvent } from '../../utilities/analytics/tracking';
import Helper from '../../utilities/analytics/helper';
import { AllowedList, PropertyByActionIndex } from '../../utilities/analytics/formConstants';

export const reportPageView = (page) => {
  if (page === undefined) return;
  gaPageView(page);
};

export const reportEvent = (action) => {
  if (action === undefined) return;

  switch (action.type) {
    case 'addressForm/validateHandler':
      gaEvent(
        gaParams.SET_ADDRESS.category,
        gaParams.SET_ADDRESS.eventType,
        Helper.objToString(action.payload, gaParams.SET_ADDRESS.eventParams)
      );
      break;
    case 'TechnicianArrivalTime/getTimeSlots/fulfilled':
      gaEvent(
        gaParams.GET_TECHNICIAN_TIMESLOTS.category,
        gaParams.GET_TECHNICIAN_TIMESLOTS.eventType,
        Helper.objToString(action.meta.arg, gaParams.GET_TECHNICIAN_TIMESLOTS.eventParams)
      );
      break;
    case 'technicianArrivalTime/validateHandler':
      gaEvent(
        gaParams.SELECT_TECHNICIAN_TIMESLOT.category,
        gaParams.SELECT_TECHNICIAN_TIMESLOT.eventType,
        Helper.objToString(action.payload, gaParams.SELECT_TECHNICIAN_TIMESLOT.eventParams)
      );
      break;
    //example without params
    // case 'technicianArrivalTime/validateHandler':
    //   gaEvent(gaParams.SELECT_TECHNICIAN_TIMESLOT_TEST.category, gaParams.SELECT_TECHNICIAN_TIMESLOT.eventType);
    //   break;
    case 'SetUpDeliveries/getDeliverySlots/fulfilled':
      gaEvent(
        gaParams.GET_DELIVERY_TIMESLOTS.category,
        gaParams.GET_DELIVERY_TIMESLOTS.eventType,
        Helper.getDeliveryParams(action.meta.arg, gaParams.GET_DELIVERY_TIMESLOTS.eventParams)
      );
      break;
    case 'saleBlock/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'saleJetBlock/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'movingBlock/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'saleBlock/reportFbqAnalytics':
      fbqEvent(action.payload.event, action.payload.data);
      break;
    case 'otpVerifyCode/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'choseNewOrExistingCellNum/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'newCellNumberSuccess/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'addressForm/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'isIBCInternetCustomer/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'orderSuccess/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'saleProducts/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'tabsContainer/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'disconnectClientService/setServiceToDisconnect':
      gaEvent(
        gaParams.DISCONNECT_CHOOSE_SERVICE_TO_DISCONNECT.category,
        gaParams.DISCONNECT_CHOOSE_SERVICE_TO_DISCONNECT.eventType,
        Helper.objToString(action.payload, gaParams.DISCONNECT_CHOOSE_SERVICE_TO_DISCONNECT.eventParams)
      );
      break;
    case 'debtPayment/getConsumers/fulfilled':
      gaEvent(
        gaParams.DEBT_PAYMENT_CLICK_CHOOSECOMPANY.category,
        gaParams.DEBT_PAYMENT_CLICK_CHOOSECOMPANY.eventType,
        gaParams.DEBT_PAYMENT_CLICK_CHOOSECOMPANY.eventParams
      );
      break;
    case 'debtPayment/getContactCompanyList/fulfilled':
      gaEvent(
        gaParams.DEBT_PAYMENT_CLICK_COMPANYLIST.category,
        gaParams.DEBT_PAYMENT_CLICK_COMPANYLIST.eventType,
        gaParams.DEBT_PAYMENT_CLICK_COMPANYLIST.eventParams
      );
      break;
    case 'updateDeliverySlot/showApprovePopup':
      gaEvent(
        gaParams.DELIVERY_SHOW_CANCEL_POPUP.category,
        gaParams.DELIVERY_SHOW_CANCEL_POPUP.eventType,
        gaParams.DELIVERY_SHOW_CANCEL_POPUP.eventParams
      );
      break;
    case 'updateDeliverySlot/setSavedSuccessfullyVisible':
      gaEvent(
        gaParams.DELIVERY_UPDATE_SUCCESS.category,
        gaParams.DELIVERY_UPDATE_SUCCESS.eventType,
        gaParams.DELIVERY_UPDATE_SUCCESS.eventParams
      );
      break;
    // case 'disconnectClientService/checkCanDisconnectService':
    //   gaEvent(gaParams.CLICK_ON_BUTTON_CONDITION_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS.category, gaParams.CLICK_ON_BUTTON_CONDITION_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS.eventType, gaParams.CLICK_ON_BUTTON_CONDITION_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS.eventParams)
    case 'extendedLeadBlock/setInitialContent':
      if (action.payload.additionalParams?.from == 'fiberNewSale') {
        gaEvent('fiber_newsale_process', 'visibility_13', action.payload.additionalParams?.productName);
      }
      break;
    case 'extendedLeadBlock/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'cellularSurfingUseDetailsBlock/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'premiumPackages/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'fundialPage/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'technicianUpdatesBlock/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'genericVasBlock/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    case 'premiumPackagesCatalog/reportAnalytics':
      gaEvent(action.payload.eventCategory, action.payload.eventAction, action.payload.eventLabel);
      break;
    default:
      break;
  }
};

export const reportFormSuccessAllWebSiteEvent = (store, action) => {
  if (store != undefined && store.iContentRepo.items != undefined && store.ViewContext != undefined) {
    try {
      let currentPath = store.ViewContext.currentPath + '/';
      let actionIndex = AllowedList.indexOf(action.type);
      let items = store.iContentRepo.items;
      let isBusiness = false;
      let leadType = action.type.split('/')[0];
      let title = store[leadType].contentData?.[PropertyByActionIndex[actionIndex]];
      let sector = '';
      if (Object.keys(items).length > 0) {
        for (let key in items) {
          if (items[key].path == currentPath) {
            let isBusinessNavigation = items[key].content.isBusinessNavigation;
            if (isBusinessNavigation.value != undefined && isBusinessNavigation.value != null) {
              isBusiness = isBusinessNavigation.value;
              break;
            }
          }
        }
      } else {
        throw 'no items in iContentRepo';
      }
      sector = isBusiness ? 'עסקי' : 'פרטי';
      gaReportFormSuccessAllWebSiteEvent(sector, title);
    } catch (e) {
      console.log(e);
    }
  }
};
